// Module
var code = "<template> <require from=\"app/core/components/member/member-codes\"></require> <member-codes member-id.bind=\"memberId\"></member-codes> </template> ";
// Exports
module.exports = code;